/* eslint-disable @typescript-eslint/no-explicit-any */
import { ComposedDrawer, ComposedDrawerProps } from '@eigtech/ui-shared-dave'
import { ReactNode } from 'react'
import { FieldValues, SubmitHandler } from 'react-hook-form'
import { FormApi } from '../useForm'

export type FormDrawerProps<
  TFieldValues extends FieldValues = FieldValues,
  TContext = any,
  TTransformedValues = TFieldValues,
> = ComposedDrawerProps & {
  form: FormApi<TFieldValues, TContext, TTransformedValues>
  submitButton?: ReactNode
  onSubmit: SubmitHandler<TTransformedValues> | undefined
}

export function FormDrawer<
  TFieldValues extends FieldValues = FieldValues,
  TContext = any,
  TTransformedValues = TFieldValues,
>({
  children,
  form,
  submitButton,
  onSubmit,
  ...props
}: FormDrawerProps<TFieldValues, TContext, TTransformedValues>) {
  const {
    formState: { isSubmitting },
  } = form

  return (
    <ComposedDrawer
      closeButtonProps={{ isDisabled: isSubmitting }}
      footerActionsRight={
        !submitButton || typeof submitButton === 'string' ? (
          <form.SubmitButton size="md">{submitButton}</form.SubmitButton>
        ) : (
          submitButton
        )
      }
      footerCloseButtonProps={{ isDisabled: isSubmitting }}
      {...props}
    >
      {onSubmit ? (
        <form.Form
          display="flex"
          flex="1"
          flexDirection="column"
          overflow="auto"
          px="2px"
          py="1px"
          onSubmit={onSubmit}
        >
          {children}
        </form.Form>
      ) : (
        children
      )}
    </ComposedDrawer>
  )
}
